import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
const pipelineTrackingStatus = v.union(
  v.literal("running"),
  v.literal("completed"),
  v.literal("failed"),
);

export const validatorPipelineTracking = v.object({
  status: pipelineTrackingStatus,
  steps: v.array(
    v.object({
      name: v.string(),
      status: v.string(),
      startTime: v.optional(v.number()),
      endTime: v.optional(v.number()),
      lastUpdate: v.optional(v.number()),
      message: v.optional(v.string()),
      output: v.optional(v.any()),
      duration: v.optional(v.number()),
      error: v.optional(v.string()),
    }),
  ),
  startTime: v.number(),
  endTime: v.optional(v.number()),
  error: v.optional(v.string()),
  duration: v.optional(v.number()),
  internalControl,
});

export const pipeline_tracking = defineTable(validatorPipelineTracking);
